/**
 * @generated SignedSource<<5cecb94427b9bd5e121bd851de7545ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoCategoryTagEditScreenTagDeleteMutation$variables = {
  categoryId: string;
  id: string;
};
export type TodoCategoryTagEditScreenTagDeleteMutation$data = {
  readonly todoCategory: {
    readonly tagDelete: {
      readonly todoCategory: {
        readonly id: string;
        readonly tags: ReadonlyArray<{
          readonly id: string;
        }>;
      };
    };
  } | null;
};
export type TodoCategoryTagEditScreenTagDeleteMutation = {
  response: TodoCategoryTagEditScreenTagDeleteMutation$data;
  variables: TodoCategoryTagEditScreenTagDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "categoryId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "categoryId"
      }
    ],
    "concreteType": "TodoCategoryMutation",
    "kind": "LinkedField",
    "name": "todoCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id"
              }
            ],
            "kind": "ObjectValue",
            "name": "input"
          }
        ],
        "concreteType": "TagDeletePayload",
        "kind": "LinkedField",
        "name": "tagDelete",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoCategory",
            "kind": "LinkedField",
            "name": "todoCategory",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategoryTag",
                "kind": "LinkedField",
                "name": "tags",
                "plural": true,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoCategoryTagEditScreenTagDeleteMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoCategoryTagEditScreenTagDeleteMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1bcd38581d6ee398dbb0ce8b043d448d",
    "id": null,
    "metadata": {},
    "name": "TodoCategoryTagEditScreenTagDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation TodoCategoryTagEditScreenTagDeleteMutation(\n  $categoryId: ID!\n  $id: ID!\n) {\n  todoCategory(id: $categoryId) {\n    tagDelete(input: {id: $id}) {\n      todoCategory {\n        id\n        tags {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "50a2f7f3b7955316930e3622d87c176f";

export default node;
